"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIFormLabel = _interopRequireDefault(require("UIComponents/form/UIFormLabel"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _MarginInput = _interopRequireDefault(require("./MarginInput"));

var _spacing = require("../constants/spacing");

var i18nKey = function i18nKey(key) {
  return "RichTextLib.marginControls." + key;
};

var Margin = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Margin, _Component);

  function Margin(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Margin);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Margin).call(this, props));
    _this.handleTopChange = _this.handleTopChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleLeftChange = _this.handleLeftChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleRightChange = _this.handleRightChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleBottomChange = _this.handleBottomChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(Margin, [{
    key: "handleTopChange",
    value: function handleTopChange(event) {
      var _this$props = this.props,
          margin = _this$props.margin,
          onMarginChange = _this$props.onMarginChange;
      var value = event.target.value;
      onMarginChange(Object.assign({}, margin, {
        top: value
      }));
    }
  }, {
    key: "handleLeftChange",
    value: function handleLeftChange(event) {
      var _this$props2 = this.props,
          margin = _this$props2.margin,
          onMarginChange = _this$props2.onMarginChange;
      var value = event.target.value;
      onMarginChange(Object.assign({}, margin, {
        left: value
      }));
    }
  }, {
    key: "handleRightChange",
    value: function handleRightChange(event) {
      var _this$props3 = this.props,
          margin = _this$props3.margin,
          onMarginChange = _this$props3.onMarginChange;
      var value = event.target.value;
      onMarginChange(Object.assign({}, margin, {
        right: value
      }));
    }
  }, {
    key: "handleBottomChange",
    value: function handleBottomChange(event) {
      var _this$props4 = this.props,
          margin = _this$props4.margin,
          onMarginChange = _this$props4.onMarginChange;
      var value = event.target.value;
      onMarginChange(Object.assign({}, margin, {
        bottom: value
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          staticPrefix = _this$props5.staticPrefix,
          margin = _this$props5.margin,
          spacingIconType = _this$props5.spacingIconType;
      var top = margin.top,
          left = margin.left,
          right = margin.right,
          bottom = margin.bottom;
      return _react.default.createElement("div", {
        className: "margin-spacing__wrapper"
      }, _react.default.createElement(_UIFormLabel.default, null, _react.default.createElement(_FormattedMessage.default, {
        message: i18nKey('spacing')
      })), _react.default.createElement(_UIFlex.default, {
        direction: "row",
        justify: "center"
      }, _react.default.createElement(_MarginInput.default, {
        value: top,
        onChange: this.handleTopChange
      })), _react.default.createElement(_UIFlex.default, {
        direction: "row",
        align: "center",
        justify: "center",
        className: "margin__spacing-icon-row"
      }, _react.default.createElement(_MarginInput.default, {
        value: left,
        onChange: this.handleLeftChange
      }), _react.default.createElement(_UIImage.default, {
        className: "image-margin__spacing-img m-all-2",
        responsive: false,
        src: staticPrefix + "/images/" + spacingIconType + "-icon.svg"
      }), _react.default.createElement(_MarginInput.default, {
        value: right,
        onChange: this.handleRightChange
      })), _react.default.createElement(_UIFlex.default, {
        className: "m-bottom-2",
        direction: "row",
        justify: "center"
      }, _react.default.createElement(_MarginInput.default, {
        value: bottom,
        onChange: this.handleBottomChange
      })));
    }
  }]);
  return Margin;
}(_react.Component);

Margin.propTypes = {
  margin: _propTypes.default.object.isRequired,
  staticPrefix: _propTypes.default.string.isRequired,
  onMarginChange: _propTypes.default.func.isRequired,
  spacingIconType: _propTypes.default.oneOf(Object.values(_spacing.SpacingIconTypes))
};
Margin.defaultProps = {
  spacingIconType: _spacing.SpacingIconTypes.EMBED
};
var _default = Margin;
exports.default = _default;
module.exports = exports.default;